import { useState, useEffect, createContext, useContext, useCallback } from "react";
import { User } from "../domain/models/User";

import { userServiceFactory } from "../services/UserServiceImpl";
import { UserRegisterDTO } from "../domain/models/dto/UserRegisterDTO";

function AuthProvider(props: any) {
    const [user, setUser] = useState<any>();
    const [loading, setLoading] = useState(true);

    const userService = userServiceFactory();

    useEffect(() => {
        (async function () {
            const currentUser = await userService.getUser();
            if (currentUser) {
                setUser(currentUser);
            }

            setLoading(false);
        })();
    }, [userService]);

    const signIn = useCallback(
        async (email: string, password: string) => {
            const result = await userService.login(email, password);
            if (result) {
                setUser(result);
            }

            return result;
        },
        [userService]
    );

    const signOut = useCallback(() => {
        setUser(undefined);
        userService.clearToken();
    }, [userService]);

    const register = useCallback(
        async (dto: User) => {
            const result = await userService.register(dto);
            if (result) {
                setUser(result);
            }

            return result;
        },
        [userService]
    );

    return <AuthContext.Provider value={{ user, signIn, signOut, register, loading }} {...props} />;
}

interface AuthorizationContext {
    user?: User;
    signIn: (email: string, password: string) => Promise<User>;
    signOut?: any;
    register?: (user: UserRegisterDTO) => Promise<User>;
    loading?: any;
}

async function defaultSignIn(_email: string, _password: string): Promise<User> {
    return;
}

const AuthContext = createContext<AuthorizationContext>({
    signIn: defaultSignIn,
});
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
